import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { CssBaseline } from '@material-ui/core';
import { StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayjsUtils from '@date-io/dayjs';

import { ErrorDisplay } from '../common/components';
import { isIE } from '../common/utils';
import {
  BrowserInstallBanner, ErrorBoundary, LocaleProvider,
} from './components';
import { Routes } from './containers';
import { GlobalStyle, theme } from './styles';
import { setupInterceptors } from './utils';
import configureStore from './configureStore';
import GrowthBookProvider from '../common/components/Growthbook/GrowthbookProvider';

const store = configureStore();

setupInterceptors(store);

const App = ({ translation }) => {
  const [visible, setVisible] = useState(isIE);

  const handleClose = () => setVisible(false);

  return (
    <StylesProvider injectFirst>
      <Provider store={store}>
        <LocaleProvider translation={translation}>
          <ThemeProvider theme={theme}>
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={DayjsUtils}>
                <CssBaseline />
                <ErrorBoundary>
                  <GlobalStyle />
                  {visible && <BrowserInstallBanner onClose={handleClose} />}
                  <GrowthBookProvider>
                    <Routes sticky={visible} />
                  </GrowthBookProvider>
                  <ErrorDisplay />
                </ErrorBoundary>
              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
          </ThemeProvider>
        </LocaleProvider>
      </Provider>
    </StylesProvider>
  );
};

App.propTypes = {
  translation: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default App;
